import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "antd/dist/reset.css";
import "./index.css";
import { AppQuery } from "./app/providers.js";
import { ErrorBoundary } from "./app/error-boundary.js";
import { Shell } from "./app/shell.js";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AppQuery>
        <Shell />
      </AppQuery>
    </ErrorBoundary>
  </StrictMode>,
);
